import React from "react";


export const ToastMessage = (icon, message) => {
    return (
    <div className='d-flex'>
        <i className={icon} style={{ fontSize: '32px', margin:'auto 0' }}></i> <p className='d-flex align-items-center ml-2 mb-0'>{message}</p>
    </div>
    );
}